var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topList_bar"},[_c('div',{staticClass:"barList_main"},_vm._l((_vm.testData),function(item){return _c('span',{key:item.id,staticClass:"barList_item",style:({
        width: `${item.width}%`,
        top: `${item.top}vw`,
        zIndex: `${item.zIndex}`,
        backgroundColor: `${item.bgColor}`,
      })})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }